import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-16 my-2 block text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" }, "Terms and conditions", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Terms", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Products", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Acceptable use", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "These Terms grant you a personal, non-exclusive, non-transferable, revocable license to access and use our Products.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "You must not:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Access our Products through scripts or other means of automation."),
  /*#__PURE__*/_createElementVNode("li", null, "Scrape our Products."),
  /*#__PURE__*/_createElementVNode("li", null, "Reverse-engineer or otherwise attempt to steal the software code of our Products.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Liability", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "NsLookup will not be liable for any direct, indirect, incidental, punitive, special, consequential or exemplary damages or loss of any kind arising from your use of the Products.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Our goal is to provide correct information, but NsLookup cannot guarantee, now will it be liable for the correctness of the content of its Products.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "NsLookup shall use reasonable efforts to protect personal information submitted by you in connection with the Products and shall use such information in accordance with the privacy policy.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Intellectual property rights", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "The Products and all of their contents, features, and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection and arrangement thereof), are owned by NsLookup, its licensors, or other providers of such material and are protected by international copyright and other intellectual property or proprietary rights laws.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Advertising content", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("The Products may present advertisements for or links to third party websites, products, and/or services (\""),
  /*#__PURE__*/_createElementVNode("strong", null, "Third Party Ads"),
  /*#__PURE__*/_createTextVNode("\"). We are not responsible for the availability of these Third Party Ads, or the images, messages, or other materials contained therein. Neither NsLookup nor any of its affiliates will be liable for any errors in content or omissions in any Third Party Ads, nor responsible for any losses or damages of any sort incurred as a result of your participation with, use of, or reliance on the Third Party Ads, including any goods, products, or services offered by such Third Party Ads.")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Termination", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "You're free to stop using our Products at any time. We also reserve the right to suspend or end the Products at any time at our discretion and without notice. For example, we may suspend or terminate your use of the Products if you're not complying with these Terms.", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "Modifications", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "We may revise these Terms from time to time. The changes will not be retroactive, and the most current version of the Terms will govern our relationship with you. By continuing to access or use our Products after those revisions become effective, you agree to be bound by the revised Terms.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", null, "Questions regarding these terms", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Last updated: 2021-03-25")
], -1)

import MetaTags from '@/components/MetaTags.vue';
import ContentPage from '@/components/layout/ContentPage.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Terms and conditions — NsLookup.io",
        description: "These are the terms and conditions for using NsLookup. You can contact us with any questions or feedback about these terms.",
        url: "https://www.nslookup.io/terms-and-conditions/"
      })
    ])),
    _createVNode(ContentPage, null, {
      content: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("p", null, [
          _createTextVNode("These Terms of Service (\""),
          _hoisted_2,
          _createTextVNode("\") govern your access to and use of the NsLookup.io website and services (\""),
          _hoisted_3,
          _createTextVNode("\"). Please read these Terms carefully, and "),
          _createVNode(_component_router_link, { to: "/contact-us/" }, {
            default: _withCtx(() => [
              _createTextVNode("contact us")
            ]),
            _: 1
          }),
          _createTextVNode(" if you have questions or feedback. By accessing or using our Products, you agree to be bound by these Terms and by our "),
          _createVNode(_component_router_link, { to: "/privacy-policy/" }, {
            default: _withCtx(() => [
              _createTextVNode("privacy policy")
            ]),
            _: 1
          }),
          _createTextVNode(". ")
        ]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("p", null, [
          _createTextVNode("Please sign up for our "),
          _createVNode(_component_router_link, { to: "/dns-lookup-api/" }, {
            default: _withCtx(() => [
              _createTextVNode("API")
            ]),
            _: 1
          }),
          _createTextVNode(" instead.")
        ]),
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("p", null, [
          _createTextVNode("If you have any questions or feedback regarding these Terms, you may "),
          _createVNode(_component_router_link, { to: "/contact-us/" }, {
            default: _withCtx(() => [
              _createTextVNode("contact us")
            ]),
            _: 1
          }),
          _createTextVNode(".")
        ]),
        _hoisted_21
      ]),
      _: 1
    })
  ], 64))
}
}

})